import React from 'react';
type FrameworkFlowProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
const steps = ['Assess', 'Plan', 'Treat', 'Track'];
export function FrameworkFlow({
  tone = 'light',
  className = ''
}: FrameworkFlowProps) {
  const chip = tone === 'dark' ? 'bg-white/10 text-white' : 'bg-teal-light text-teal-deep';
  const arrow = tone === 'dark' ? 'text-white/40' : 'text-teal-mid';
  return <ul className={`flex items-center justify-center gap-1.5 ${className}`} aria-label="Assess, Plan, Treat, Track framework" data-id="element-44" data-mp="dk2y3d0qwxp2">
      {steps.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-45" data-mp="3ut4fsq976yu" data-mpi={index}>
          <span className={`rounded-full px-3 py-1.5 text-[0.66rem] font-semibold uppercase tracking-[0.12em] sm:px-3.5 sm:text-[0.72rem] ${chip}`} data-id="element-46" data-mp="3t8e6faz2a6s">
            {step}
          </span>
          {index < steps.length - 1 ? <span className={`text-[0.7rem] ${arrow}`} aria-hidden="true" data-id="element-47" data-mp="rjujvzxi7idm">
              →
            </span> : null}
        </li>)}
    </ul>;
}